import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core'
import { MatInputModule } from '@angular/material/input'
import { AddressTypeService } from '../../../core/services/address/address-type/address-type.service'
import {
  MatCell,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderRow,
  MatRow,
  MatTable,
  MatTableDataSource,
  MatTableModule,
} from '@angular/material/table'
import { MatIcon } from '@angular/material/icon'
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator'
import { generateHexId } from '../../../shared/utils/utils'
import { MatButton } from '@angular/material/button'
import { MatDialog } from '@angular/material/dialog'
import { ItemProposalCreateFormComponent } from './item-proposal-create-form/item-proposal-create-form.component'
import { JsonPipe, NgClass } from '@angular/common'

@Component({
  selector: 'item-proposal-create',
  imports: [
    MatInputModule,
    MatCell,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatIcon,
    MatPaginator,
    MatRow,
    MatTable,
    MatTableModule,
    MatIcon,
    MatPaginatorModule,
    MatTable,
    MatButton,
    NgClass,
    JsonPipe,
  ],
  templateUrl: './item-proposal-create.component.html',
  styleUrl: './item-proposal-create.component.scss',
  providers: [AddressTypeService],
  standalone: true,
})
export class ItemProposalCreateComponent
  implements OnInit, AfterViewInit, OnChanges
{
  constructor(private dialog: MatDialog) {}

  item: any = {}
  itemsList: any[] = []

  @Output() response = new EventEmitter<any>()
  @Input() idClient = -1
  @Input() listItems: any[] = []
  @Input() period: any = {
    dataInicio: '',
    dataFim: '',
    dataInicioDescription: '',
    dataFimDescription: '',
  }

  @ViewChild(MatPaginator) paginator: MatPaginator | undefined
  @ViewChild(MatTable) table: MatTable<any> | undefined

  columns: any[] = [
    {
      keyColumn: 'location_OD',
      key: 'origem',
      description: 'Trecho',
    },
    {
      keyColumn: 'servico_TS',
      key: 'tipoServico',
      description: 'Serviço',
    },
    {
      keyColumn: 'vehicle_VM',
      key: 'tipoVeiculo',
      description: 'Veículo',
    },
    {
      keyColumn: 'cost_IP',
      key: 'vendaFormatado',
      description: 'Venda',
    },
    {
      keyColumn: 'custoExtra_HK',
      key: 'vendaFormatado',
      description: 'Venda Extra',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true, duplicate: true },
      description: 'Ações',
    },
  ]
  tableSource: MatTableDataSource<any> = new MatTableDataSource<any>()
  displayedColumns: string[] = [
    'location_OD',
    'servico_TS',
    'vehicle_VM',
    'cost_IP',
    'custoExtra_HK',
    'action',
  ]

  ngOnInit(): void {
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
  }

  ngAfterViewInit() {
    this.refreshTable()
  }

  ngOnChanges(changes: SimpleChanges) {
    // Semeia a tabela com itens restaurados de um rascunho (continuar proposta).
    if (changes['listItems'] && this.listItems && this.listItems.length > 0) {
      this.itemsList = this.listItems
      this.tableSource = new MatTableDataSource<any>(this.itemsList)
      this.refreshTable()
      this.response.emit(this.itemsList)
    }
    // Limpa os itens quando o cliente muda manualmente. Ignora quando a mudança
    // veio junto com listItems (restauração de rascunho), senão apagaria os itens.
    if (changes['idClient'] && !changes['listItems']) {
      this.itemsList = []
      this.tableSource = new MatTableDataSource<any>(this.itemsList)
      this.refreshTable()
      this.response.emit(this.itemsList)
    }
  }

  refreshTable() {
    if (this.paginator) {
      this.tableSource.paginator = this.paginator
    }
    if (this.table) {
      this.table.renderRows()
    }
  }

  responseForm(element: any) {
    switch (element.action) {
      case 'create':
        this.includeItem(element.item)
        return
      case 'edit':
        this.updateItem(element.item)
        return
      case 'delete':
        this.deleteItemEvent(element.index)
        return
      case 'cancel':
        this.item = {}
        return
    }
  }

  generateId() {
    let id = generateHexId()
    if (this.itemsList.length == 0) {
      return id
    } else {
      let idDistinct = false
      while (!idDistinct) {
        if (
          this.itemsList.findIndex((ele: any) => {
            return ele.idCreate == id
          }) == -1
        ) {
          idDistinct = true
        } else {
          id = generateHexId()
        }
      }
      return id
    }
  }

  getCityState(element: any) {
    const model = {
      cidadeOrigem: '',
      estadoOrigem: '',
      cidadeDestino: '',
      estadoDestino: '',
    }
    if (element.origin) {
      model.cidadeOrigem = element.origin.cidade ?? '-'
      model.estadoOrigem = element.origin.estado ?? '-'
    }
    if (element.destination) {
      model.cidadeDestino = element.destination.cidade ?? '-'
      model.estadoDestino = element.destination.estado ?? '-'
    }
    return model
  }

  includeItem(element: any) {
    const cidadeEstado = this.getCityState(element)
    this.itemsList.push({
      ...element,
      idCreate: this.generateId(),
      ...cidadeEstado,
    })
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.response.emit(this.itemsList)
  }

  updateItem(element: any) {
    const index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    const cidadeEstado = this.getCityState(element)
    this.itemsList.splice(
      index,
      1,
      (({ index, ...rest }) => rest)({ ...element, ...cidadeEstado }),
    )
    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    // this.item = {}
    this.response.emit(this.itemsList)
  }

  deleteItemEvent(element: any) {
    const index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    if (index >= 0) {
      this.itemsList.splice(index, 1)
      this.tableSource = new MatTableDataSource<any>(this.itemsList)
      this.refreshTable()
      this.response.emit(this.itemsList)
    }
  }

  duplicateItemProposal(element: any) {
    const index = this.itemsList.findIndex((ele: any) => {
      return ele.idCreate == element.idCreate
    })
    const newItem = { ...structuredClone(element), idCreate: this.generateId() }
    // this.itemsList.splice(index, 0, newItem)
    this.itemsList.push(newItem)

    this.tableSource = new MatTableDataSource<any>(this.itemsList)
    this.refreshTable()
    this.response.emit(this.itemsList)

    // if (index >= 0) {
    //   const duplicatedItem = {...element}
    //   this.itemsList.splice(index + 1, 0, duplicatedItem)
    //   this.tableSource = new MatTableDataSource<any>(this.itemsList)
    //   this.refreshTable()
    //   this.response.emit(this.itemsList)
    // }
  }

  selectItemEvent(element: any) {
    // this.item = element
    const dialogRef = this.dialog.open(ItemProposalCreateFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: true, item: element, idClient: this.idClient },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.updateItem(response)
      }
    })
  }

  addItemProposal() {
    const dialogRef = this.dialog.open(ItemProposalCreateFormComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { idClient: this.idClient, period: this.period },
    })
    dialogRef.componentInstance.response.subscribe((response) => {
      if (response) {
        this.includeItem(response)
      }
    })
  }

  validInsert() {
    if (
      this.period.dataInicio == '' ||
      this.period.dataInicio == 'Invalid date' ||
      this.period.dataFim == '' ||
      this.period.dataFim == 'Invalid date'
    ) {
      return false
    } else {
      return true
    }
  }
}
